import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Row } from "./RowsAllUsers";
import { Box, TablePagination } from "@mui/material";
import ModalDeleteMember from "./ModalDeleteMember";

export default function TableAllRunningClubProvider({
  rows = [],
  setLoading,
  selectedClub,
}) {
  const [page, setPage] = React.useState(0);
  const [showModalDeleteMember, setShowModalDeleteMember] =
    React.useState(false);
  const [selectedMember, setSelectedMember] = React.useState(null);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = React.useMemo(() => {
    if (!rows || rows.length === 0) return [];

    return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [page, rowsPerPage, rows]);

  return (
    <>
      <ModalDeleteMember
        open={showModalDeleteMember}
        selecteMember={selectedMember}
        setLoading={setLoading}
        setShowModalDelete={setShowModalDeleteMember}
        selectedClub={selectedClub}
      />
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>Nombre</TableCell>
                  <TableCell align="center">NickName</TableCell>
                  <TableCell align="center">Correo</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows.map((row) => (
                  <Row
                    key={row._id}
                    row={row}
                    setSelectedMember={setSelectedMember}
                    setShowModalDeleteMember={setShowModalDeleteMember}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
}
